<!-- TODO dialog title? -->

<mat-dialog-content [formGroup]="contactDialogForm">
  <contact-manager [contact]="contact" (viewChange)="onViewChanged($event)">
  </contact-manager>
</mat-dialog-content>

@if (!childViewShown) {
  <mat-divider></mat-divider>
}

@if (!childViewShown) {
  <mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
    <button mat-button (click)="cancelClicked()" telemetry="Submission-ContactManagerCancel">
      Cancel
    </button>
    <button mat-button (click)="doneClicked()" telemetry="Submission-ContactManagerDone">
      Done
    </button>
  </mat-dialog-actions>
}